import React from 'react'
import LIveMatch from '../Component/Live/LIveMatch'
import NavBar from '../Component/Nav/NavBar'

const Live = () => {
  return (
    <div>
      <NavBar />
      <LIveMatch />
    </div>
  )
}

export default Live
